import { GenericApiResponse, PostTransfer, TransferBeteweenWarehouse } from "interfaces";
import { post } from "services/services.methods";
import { WarehouseTransferPaths, WarehouseTransferReportPaths } from "services/services.paths";

export const createTransfer = async (payload: PostTransfer) => {
  const respTransfer = await post<any>(WarehouseTransferPaths.post, payload);

  return respTransfer;
};


export const getlistTansfer = async (
  purchaseParams: { warehouseFromId: number; dateFrom: string; dateTo: string; warehouseToId: number; transferId: number }
): Promise<GenericApiResponse<TransferBeteweenWarehouse[]>> => {
  
  const url = `${WarehouseTransferReportPaths.post}?warehouseFromId=${purchaseParams.warehouseFromId}&dateFrom=${purchaseParams.dateFrom}&dateTo=${purchaseParams.dateTo}&warehouseToId=${purchaseParams.warehouseToId}&transferId=${purchaseParams.transferId}`;
  const response = await post<TransferBeteweenWarehouse[]>(WarehouseTransferReportPaths.post, purchaseParams);


  return response;
};